export const findingViewGeneratedKeys = ['__findingViewIds', '__contextRuleIds', '__variableIds'];
export const findingViewType_Parent = 'parent';
export const findingViewType_Sections = 'sections';
export const findingViewTypes = [findingViewType_Parent, findingViewType_Sections];
//# sourceMappingURL=types.js.map